import { type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Label({ className, children, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={cn(
        'block text-[11px] font-semibold uppercase tracking-wide text-[#676687] dark:text-[#8888AA] mb-1.5',
        className,
      )}
      {...rest}
    >
      {children}
    </label>
  );
}
